import { render, staticRenderFns } from "./SettingForm.vue?vue&type=template&id=2c4eaebc&scoped=true"
import script from "./SettingForm.vue?vue&type=script&lang=js"
export * from "./SettingForm.vue?vue&type=script&lang=js"
import style0 from "./SettingForm.vue?vue&type=style&index=0&id=2c4eaebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4eaebc",
  null
  
)

export default component.exports